<template>
  <div v-if="trial" class="footer__trial">
    <v-icon small color="primary">
      mdi-clock-outline
    </v-icon>

    <span class="footer__trial-text">
      {{ $t('trial.footer.label') }}:
      <strong>{{ trialCountdown }}</strong>
    </span>

    <router-link :to="{ name: 'myPlan' }">
      {{ $t('trial.footer.seePlan') }}
    </router-link>
  </div>
</template>

<script>
import { companyTrial } from '@/util/paywall'

/**
 * The running-trial pill. Positioning lives on the parent (`FooterNotices`); this component owns only
 * whether it has something to say.
 *
 * Its route exclusions are its own list rather than the balance pill's: the two happen to overlap
 * today, and sharing the constant would silently couple them the next time one of them changes.
 */
const NO_TRIAL_NOTICE_ROUTES = ['login', 'rootLogin', 'quote', 'onboarding', 'onboardingSteps']

export default {
  name: 'TrialFooter',

  data() {
    return {
      trial: null,
    }
  },

  computed: {
    /**
     * The last day reads "ends today", not "1 day left" — an off-by-one here is the difference
     * between a customer expecting one more day of access and losing it overnight.
     */
    trialCountdown() {
      const { daysLeft } = this.trial

      if (daysLeft === 0) return this.$t('trial.footer.endsToday')
      if (daysLeft === 1) return this.$t('trial.footer.oneDayLeft')
      return this.$t('trial.footer.daysLeft', { count: daysLeft })
    },
  },

  watch: {
    // Re-read per route so the pill is correct after a login that does not reload the page. The
    // lookup itself is cached for the page load, so this costs nothing after the first answer.
    $route: {
      immediate: true,
      handler() {
        this.loadTrial()
      },
    },
  },

  methods: {
    /**
     * Shares the paywall's cached entitlement lookup, so this costs no request of its own. Failure is
     * silence: `companyTrial` resolves to null rather than rejecting, and a missing pill is a far
     * better outcome than a wrong one.
     */
    async loadTrial() {
      if (NO_TRIAL_NOTICE_ROUTES.includes(this.$route.name)) {
        this.trial = null
        return
      }

      this.trial = await companyTrial()
    },
  },
}
</script>
